/** Which device type a setting is hidden on. BOTH is for reasons unrelated to the device, e.g. a missing license */
export enum HIDE_IN {
  BOTH = 'BOTH',
  HANDY = 'HANDY',
  TABLET = 'TABLET',
}

/** One toggle row in a settings scene */
export type TogglesConfig = {
  label: string;
  subLabel?: string;
  key: string;
  storage: any;
  /** Will reverse the value of the storage */
  inverted?: boolean;
  hideIn?: HIDE_IN;
};

/** True when a setting with the given `hideIn` should not be rendered on this device */
export const isHiddenOnDevice = (hideIn: HIDE_IN | undefined, isHandy: boolean) =>
  hideIn === HIDE_IN.BOTH ||
  (hideIn === HIDE_IN.HANDY && isHandy) ||
  (hideIn === HIDE_IN.TABLET && !isHandy);
